export default ({ $api }) => {
  $api.register('bank', '/web/public/bank', request => ({
    getAll: () => request('GET'),
  }));
};
